import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import { useWindowSize } from '../hooks/useWindowSize';

const StyledButton = styled.button`
  position: relative;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: ${props => props.isMobile ? '0.4rem' : '0.5rem'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.isMobile ? '1.3rem' : '1.5rem'};
  width: ${props => props.isMobile ? '2rem' : '2.5rem'};
  height: ${props => props.isMobile ? '2rem' : '2.5rem'};
  color: ${props => props.isDarkMode ? '#ffffff' : '#333333'};
  
  /* Переопределяем глобальные transitions для более точного контроля */
  transition: transform 0.2s ease, background-color 0.2s ease !important;
  transform: scale(1);
  
  &:hover {
    background-color: ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
    transform: scale(1.1);
    border-radius: 50%; /* Принудительно сохраняем круглую форму */
  }
  
  &:active {
    transform: scale(0.95);
    background-color: ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'};
  }
  
  /* Принудительно сбрасываем состояние когда не hover */
  &:not(:hover):not(:active) {
    background-color: transparent;
    transform: scale(1);
  }
  
  /* Стили для touch устройств */
  @media (hover: none) and (pointer: coarse) {
    &:hover {
      background-color: transparent;
      transform: scale(1);
    }
    
    &:active {
      background-color: ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
      transform: scale(0.95);
    }
  }
`;

const IconSpan = styled.span`
  display: block;
  transition: filter 0.2s ease !important;
  filter: ${props => props.isDarkMode ? 'brightness(1.2)' : 'brightness(1)'};
  user-select: none;
  pointer-events: none; /* Предотвращаем события на иконке */
`;

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  // Получаем иконку в зависимости от текущего режима
  const getIcon = () => {
    return isDarkMode ? '🌙' : '☀️';
  };

  // Получаем tooltip текст
  const getTooltipText = () => {
    return isDarkMode ? 'Switch to light theme' : 'Switch to dark theme';
  };

  return (
    <StyledButton
      onClick={toggleTheme}
      title={getTooltipText()}
      data-testid="theme-toggle"
      isDarkMode={isDarkMode}
      isMobile={isMobile}
      type="button"
    >
      <IconSpan isDarkMode={isDarkMode}>
        {getIcon()}
      </IconSpan>
    </StyledButton>
  );
};

export default ThemeToggle; 